<template>
  <div style="padding: 10px 15px;">
    <a-row :gutter="16">
      <a-col class="col-mb" :xs="24" :md="6" @click="routeTo('1F.A01.S01')">
        <a-card>
          <div class="info-icon"><a-icon type="info-circle" /></div>
          <h3>新厂房小货架S01</h3>
        </a-card>
      </a-col>
      <a-col class="col-mb" :xs="24" :md="6" @click="routeTo('1F.A01.S02')">
        <a-card>
          <div class="info-icon"><a-icon type="info-circle" /></div>
          <h3>新厂房小货架S02</h3>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    routeTo (stockPosition) {
      this.$router.push({ path: '/factory/exhibit/table', query: { stockPosition } })
    }
  }
}
</script>

<style>
.col-mb {
  margin-bottom: 10px;
  /* cursor: pointer; */
}
.ant-card-body {
  cursor: pointer;
}
.info-icon {
  float: right;
  color: #1890ff;
}
</style>
